import { defineMessages } from 'react-intl';

const scope = 'app.course.builder.unit';

export default defineMessages({
  deleteKnowledgeMap: {
    id: `${scope}.deleteKnowledgeMap`,
    defaultMessage: 'Delete Knowledge Map',
  },
  modalConfirmationTitle: {
    id: `${scope}.modalConfirmationTitle`,
    defaultMessage: 'Delete {toBeDeletedDocumentName} Knowledge Map?',
  },
  modalConfirmationItemChildTitle: {
    id: `${scope}.modalConfirmationItemChildTitle`,
    defaultMessage: 'Are you sure you want to delete this objective?',
  },
  modalConfirmationItemParentTitle: {
    id: `${scope}.modalConfirmationItemParentTitle`,
    defaultMessage: 'Are you sure you want to delete this objective and all the objectives associated with it?',
  },
  modalConfirmationDescriptionItem: {
    id: `${scope}.modalConfirmationDescriptionItem`,
    defaultMessage: 'You will not be able to recover this objective once deleted. Are you sure you want to continue?',
  },
  modalConfirmationDescription: {
    id: `${scope}.modalConfirmationDescription`,
    defaultMessage: 'You will not be able to recover this map once deleted. Are you sure you want to continue?',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
});
